export default __webpack_public_path__ + "static/media/2.baa79a00.jpg";